import { useContext } from 'react'

import { AuthContext } from '@presentation/contexts'
import { useLocation } from 'react-router-dom'
import { PermissaoRequisito, PermissaoTipo } from '@core/models/entities'

const tiposPermissaoCanonicos = Object.values(PermissaoTipo)

const isTipoPermissaoCanonico = (tipo: unknown): tipo is PermissaoTipo =>
  typeof tipo === 'string' &&
  tiposPermissaoCanonicos.includes(tipo as PermissaoTipo)

export const useAuth = () => {
  const location = useLocation()
  const { getCurrentAccount } = useContext(AuthContext)

  const currentAccount = getCurrentAccount()

  const hasPermission = (permissionType: PermissaoTipo) => {
    if (currentAccount) {
      const matchPermissions = currentAccount.permissoes
        .filter(permissao => {
          const hasAccessRoute = location.pathname.startsWith(permissao.nome)

          return hasAccessRoute
        })
        .sort((left, right) => right.nome.length - left.nome.length)

      if (matchPermissions.length > 0) {
        const routePermission = matchPermissions[0]
        const routePermissionTypes = routePermission.tipo.split('')

        if (routePermissionTypes.includes(permissionType)) {
          return true
        }
      }
    }

    return false
  }

  const canAccessRoute = (path: string) => {
    if (currentAccount) {
      const canAccess = currentAccount.permissoes.some(
        permissao =>
          path.startsWith(permissao.nome) || permissao.nome.startsWith(path)
      )

      return canAccess
    }

    return false
  }

  const hasExplicitPermission = ({
    nome,
    tipo
  }: PermissaoRequisito): boolean => {
    if (!currentAccount?.permissoes || !isTipoPermissaoCanonico(tipo)) {
      return false
    }

    return currentAccount.permissoes.some(permissao => {
      if (permissao.nome !== nome || !isTipoPermissaoCanonico(permissao.tipo)) {
        return false
      }

      return permissao.tipo.includes(tipo)
    })
  }
  return {
    getCurrentAccount,
    hasPermission,
    canAccessRoute,
    hasExplicitPermission
  }
}
